import React from 'react';
import './featureCard.scss';


function FeatureCard(props) {
    return (
        <div className="comp-feature-card ">
            <embed src={props.data.icon} type="image/svg+xml"/>
            <div className='title'>{props.data.title}</div>
            <div className='sub-title'>{props.data.subtitle}</div>
            <div className='desc'>{props.data.desc}</div>
        </div>
    );
}

export default FeatureCard;
